import { render, staticRenderFns } from "./ActionsTextEditor.vue?vue&type=template&id=1564f58c"
import script from "./ActionsTextEditor.vue?vue&type=script&lang=js"
export * from "./ActionsTextEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports